import { render, staticRenderFns } from "./addShippingAddress.vue?vue&type=template&id=4665a62a"
import script from "./addShippingAddress.vue?vue&type=script&lang=js"
export * from "./addShippingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports